import { hFetch } from '@/lib/hfetch';
import type {
  WorkflowScheduledActionParams,
  WorkflowActionableParams,
  WorkflowActionEntity,
  WorkflowActionParams,
} from './entity_types/workflow/WorkflowAction';

type CreateWorkflowActionArgs = {
  workflowId: number;
  actionParams: WorkflowActionParams;
  actionableParams: WorkflowActionableParams;
  scheduledActionParams?: WorkflowScheduledActionParams;
};
export const create = ({
  workflowId,
  actionParams,
  actionableParams,
  scheduledActionParams,
}: CreateWorkflowActionArgs) => {
  return hFetch<WorkflowActionEntity, unknown>({
    url: `/api/workflows/${workflowId}/actions`,
    method: 'POST',
    payload: {
      workflow_action: {
        action_params: actionParams,
        actionable_params: actionableParams,
        scheduled_action_params: scheduledActionParams,
      },
    },
  });
};

type UpdateWorkflowActionArgs = {
  workflowId: number;
  workflowActionId: number;
  actionParams?: WorkflowActionParams;
  actionableParams?: WorkflowActionableParams;
  scheduledActionParams?: WorkflowScheduledActionParams;
};
export const update = ({
  workflowId,
  workflowActionId,
  actionParams,
  actionableParams,
  scheduledActionParams,
}: UpdateWorkflowActionArgs) => {
  return hFetch<WorkflowActionEntity, unknown>({
    url: `/api/workflows/${workflowId}/actions/${workflowActionId}`,
    method: 'PUT',
    payload: {
      workflow_action: {
        action_params: actionParams,
        actionable_params: actionableParams,
        scheduled_action_params: scheduledActionParams,
      },
    },
  });
};

type DeleteWorkflowActionArgs = {
  workflowId: number;
  workflowActionId: number;
};
export const destroy = ({ workflowId, workflowActionId }: DeleteWorkflowActionArgs) => {
  return hFetch<WorkflowActionEntity>({
    url: `/api/workflows/${workflowId}/actions/${workflowActionId}`,
    method: 'DELETE',
  });
};
